import React from 'react';

const HeaderTop = () => {
    return (
        <div className="topbar">
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-lg-5 col-12">
                        <ul className="contact-info">
                            <li>
                                <i className="ti-email"></i><span>info@ofllogistics.com</span>
                            </li>
                            <li>
                                <a href="tel:1300100868">
                                    <i className="flaticon-call"></i><span>1300 100 868</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="col-lg-7 col-12">
                        <div className="contact-into">
                            {/* <LanguageSelector/>
                            <div className="pryment-selector">
                                <select>
                                    <option value="usd">USD</option>
                                    <option value="aud">AUD</option>
                                </select>
                            </div> */}
                            <ul className="social-media">
                                <li><span>Follow Us :</span></li>
                                <li>
                                    <a
                                        href="https://www.facebook.com/?_rdc=1&_rdr#"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <i className="flaticon-facebook-app-symbol"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                                        <i className="fa-brands fa-instagram"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                                        <i className="fa-brands fa-x-twitter"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
                                        <i className="fa-brands fa-youtube"></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeaderTop;